import Auth from '../api/auth';
import { clearCookiesOnLogout } from '../store/utils/api';

let isUnauthorizedLogoutInProgress = false;

const getErrorMessage = error =>
  error?.response?.data?.error ||
  error?.response?.data?.message ||
  error?.response?.data?.errors?.[0] ||
  '';

const isAuthorizationFailure = error => {
  const errorMessage = String(getErrorMessage(error)).toLowerCase();

  return [
    'not authorized',
    'no autorizado',
    'unauthorized to do this action',
    'non permissible resource',
    'invalid user ids',
    'account is suspended',
  ].some(message => errorMessage.includes(message));
};

const shouldForceLogout = error =>
  error?.response?.status === 401 &&
  Auth.hasAuthCookie() &&
  !isAuthorizationFailure(error);

const parseErrorCode = error => {
  if (shouldForceLogout(error) && !isUnauthorizedLogoutInProgress) {
    isUnauthorizedLogoutInProgress = true;
    clearCookiesOnLogout();
  }

  return Promise.reject(error);
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
